import React, { Component } from 'react';
import {
  FormGroup,
  Input,
  Button,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import { actions, Control, Errors } from 'react-redux-form/immutable';
import PropTypes from 'prop-types';
import { Map, fromJS } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { AddIcon } from '../../../../../icon/AddIcon';
import {
  getVolcanoLocations as getVolcanoLocationsAc,
} from '../../../../../../redux/volcanoes/event/edit/volcanoEventEditActions';
import { fieldToNumber, fieldTrimmed } from '../../../../../form/formUtilities';
import { SingleResultGrid } from '../../../../../grid/SingleResultGrid';
import { Column } from '../../../../../grid/Column';
import { Loading } from '../../../../../loadbar/Loading';
import { ResultGrid } from '../../../../../grid/ResultGrid';
import {
  volLocVisibleColumns,
  volLocSort,
  minColumns,
} from '../../../../../../redux/EditReduxConstant';

const defaultMap = fromJS({});

class VolcanoLocationSearchControlUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.searchVolcanoLocations = this.searchVolcanoLocations.bind(this);
    this.addLocation = this.addLocation.bind(this);
    this.handleToggleColumns = this.handleToggleColumns.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.renderAddButton = this.renderAddButton.bind(this);
    this.state = {
      volcanoLocations: Map(),
      searchVisible: false,
      searchInput: '',
    };
  }

  componentDidMount() {
    const { volcanoLocation } = this.props;
    this.setState((state) => {
      const volcanoLocationId = volcanoLocation.get('id');
      const volcanoLocations = volcanoLocationId ? state.volcanoLocations.set(`${volcanoLocationId}`, volcanoLocation) : state.volcanoLocations;
      return {
        volcanoLocations,
      };
    });
  }

  searchVolcanoLocations() {
    const { getVolcanoLocations, history } = this.props;
    const { searchInput } = this.state;
    getVolcanoLocations({
      history,
      queryParameters: {
        op: 'or',
        nameInclude: fieldTrimmed(searchInput),
        id: fieldToNumber(searchInput),
        country: fieldTrimmed(searchInput),
        num: fieldTrimmed(searchInput),
      },
    });
  }

  addLocation(location) {
    const { volcanoLocation, change, model } = this.props;
    const id = location ? location.get('id') : '';
    this.setState((state) => {
      const volcanoLocations = state.volcanoLocations.filter(exitingLoc => exitingLoc.get('id') === volcanoLocation.get('id'));
      return {
        volcanoLocations: volcanoLocations.set(`${id}`, location),
      };
    }, () => {
      change(`${model}.volcanoLocationId`, `${id}`);
    });
  }


  handleToggleColumns({ visibleColumns, sort }) {
    const {
      visibleColumns: preVisibleColumns, sort: prevSort, sortData, toggleColumns,
    } = this.props;
    let changed = false;
    if (!visibleColumns.sort().equals(preVisibleColumns.sort())) {
      toggleColumns(visibleColumns);
      changed = true;
    }
    if (!sort.equals(prevSort)) {
      sortData(sort);
      changed = true;
    }
    return changed;
  }

  toggleSearch() {
    this.setState(({ searchVisible: prev }) => ({ searchVisible: !prev }));
  }

  renderAddButton({ row }) {
    const { volcanoLocationId } = this.props;
    if (`${row.get('id')}` !== volcanoLocationId) {
      return (<AddIcon handleClick={() => this.addLocation(row)} />);
    }
    return (<div />);
  }

  render() {
    const {
      locationSearching, volcanoLocationSearchResults, volcanoLocationId, sort, valid, visibleColumns,
    } = this.props;
    const { volcanoLocations, searchVisible } = this.state;
    return (
      <Card>
        <CardBody>
          <CardTitle tag="h2">Volcano Location</CardTitle>
          <SingleResultGrid data={volcanoLocations.get(volcanoLocationId) ? volcanoLocations.get(volcanoLocationId) : defaultMap}>
            <Column id="id" width={100}>NCEI ID</Column>
            <Column id="newNum" width={150} sortable helpModalId="volLocNewNum">Volcano Number</Column>
            <Column id="num" width={100} helpModalId="volLocNum">Prev Vol Number</Column>
            <Column id="name" width={150} helpModalId="volLocName">Volcano Name</Column>
            <Column id="country" width={150}>Country</Column>
          </SingleResultGrid>
          <div className="form-group sr-only">
            <Control type="hidden" model=".volcanoLocationId" />
          </div>
          <Errors
            model=".volcanoLocationId"
            component="div"
            wrapper={({ children }) => <div className={classnames({ 'invalid-feedback': true, 'haz-associated-table-error': !valid })}>{children}</div>}
          />
          {searchVisible ? (
            <Card>
              <CardBody>
                <CardTitle tag="h2" className="haz-close-title">
                  <span>Search</span>
                  <button type="button" className="close" aria-label="Close" onClick={this.toggleSearch}>x</button>
                </CardTitle>
                <div className="haz-assoc-search-container">
                  <div className="form-inline">
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                      <Input disabled={locationSearching} onChange={(e) => { this.setState({ searchInput: e.target.value }); }} type="text" />
                    </FormGroup>
                    <Button disabled={locationSearching} onClick={this.searchVolcanoLocations}>Search</Button>
                  </div>

                  <div className="haz-assoc-search">
                    {locationSearching ? (<Loading />) : (
                      <ResultGrid
                        data={volcanoLocationSearchResults}
                        sort={sort}
                        handleColumnsToggle={this.handleToggleColumns}
                        columnChooser
                        visibleColumns={visibleColumns}
                        defaultColumns={volLocVisibleColumns}
                        defaultSort={volLocSort}
                        minColumns={minColumns}
                      >
                        <Column id="add" width={50} alwaysVisible cell={this.renderAddButton}><AddIcon /></Column>
                        <Column id="id" width={100} sortable>NCEI ID</Column>
                        <Column id="newNum" width={150} sortable helpModalId="volLocNewNum">Volcano Number</Column>
                        <Column id="num" width={150} sortable helpModalId="volLocNum">Prev Vol Number</Column>
                        <Column id="name" width={200} sortable helpModalId="volLocName">Volcano Name</Column>
                        <Column id="country" width={200} sortable>Country</Column>
                      </ResultGrid>
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          ) : (<Button onClick={this.toggleSearch}>Search</Button>)}

        </CardBody>
      </Card>
    );
  }
}


VolcanoLocationSearchControlUnwrapped.propTypes = {
  model: PropTypes.string.isRequired,
  volcanoLocation: ImmutablePropTypes.map.isRequired,
  getVolcanoLocations: PropTypes.func.isRequired,
  locationSearching: PropTypes.bool.isRequired,
  volcanoLocationSearchResults: ImmutablePropTypes.list.isRequired,
  change: PropTypes.func.isRequired,
  volcanoLocationId: PropTypes.string.isRequired,
  sortData: PropTypes.func.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  valid: PropTypes.bool.isRequired,
  history: PropTypes.shape({}).isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
};


const mapStateToProps = (state, { model }) => ({
  locationSearching: state.getIn(['volcanoEventEditPage', 'locationSearching']),
  volcanoLocationSearchResults: state.getIn(['volcanoEventEditPage', 'volcanoLocationSearchResults']),
  volcanoLocationId: state.getIn([model, 'volcanoLocationId']) ? state.getIn([model, 'volcanoLocationId']) : '',
  valid: state.get('forms')[model].volcanoLocationId.valid,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getVolcanoLocations: getVolcanoLocationsAc,
  change: actions.change,

}, dispatch);

export const VolcanoLocationSearchControl = connect(mapStateToProps, mapDispatchToProps)(VolcanoLocationSearchControlUnwrapped);
